(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function heroToggleMute(sectionId) {
    var hero = document.getElementById('Hero-' + sectionId);
    var videos = hero.querySelectorAll('video');
    var btn = document.getElementById('hero-mute-btn-' + sectionId);
    var mutedIcon = btn.querySelector('.hero__mute-icon--muted');
    var unmutedIcon = btn.querySelector('.hero__mute-icon--unmuted');

    videos.forEach(function(video) {
      video.muted = !video.muted;
    });

    if (videos[0] && videos[0].muted) {
      mutedIcon.style.display = '';
      unmutedIcon.style.display = 'none';
    } else {
      mutedIcon.style.display = 'none';
      unmutedIcon.style.display = '';
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
